import { useEffect, useState } from "react";

const links = [
  { href: "#books", label: "Bücher", testId: "nav-link-books" },
  { href: "#manifesto", label: "Manifest", testId: "nav-link-manifesto" },
  { href: "#author", label: "Autor", testId: "nav-link-author" },
  { href: "#faq", label: "FAQ", testId: "nav-link-faq" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-void/85 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 h-16 sm:h-20 flex items-center justify-between">
        <a href="#top" data-testid="header-logo-button" className="flex items-center gap-3 group">
          <img
            src="/logo.png"
            alt="Schattenpsyche Logo"
            className="w-9 h-9 sm:w-10 sm:h-10 rounded-full ring-1 ring-white/20 group-hover:ring-white/70 transition-all duration-300 group-hover:shadow-[0_0_18px_rgba(255,255,255,0.3)]"
          />
          <span className="font-cinzel tracking-[0.25em] text-xs sm:text-sm text-white/90 group-hover:text-white transition-colors duration-300">
            SCHATTENPSYCHE
          </span>
        </a>
        <nav className="hidden md:flex items-center gap-8 font-mono text-[11px] uppercase tracking-[0.25em] text-slate-400">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testId}
              className="hover:text-white transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <a
          href="#books"
          data-testid="header-cart-button"
          className="glow-btn !px-5 !py-2.5 text-sm"
        >
          Buch sichern
        </a>
      </div>
    </header>
  );
};
